import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getRequest } from './apiWrapper';

// ログインページ
import TeacherLoginPage from './pages/TeacherLoginPage';
import AdminLoginPage from './pages/AdminLoginPage';

// 教師用ページ
import TeacherDashboard from './pages/report/TeacherDashboard';
import TodayStudentSelection from './pages/report/TodayStudentSelection';
import StudentGoalsPage from './pages/report/StudentGoalsPage';
import TeacherNotificationsPage from './pages/report/TeacherNotificationsPage';

// 管理者用ページ
import AdminDashboard from './pages/report/AdminDashboard';
import AdminTeachers from './pages/report/AdminTeachers';
import AdminStudents from './pages/report/AdminStudents';
import AdminParents from './pages/report/AdminParents';
import AdminTeacherAssignments from './pages/report/AdminTeacherAssignments';
import AdminReportsPage from './pages/report/AdminReportsPage';
import AdminEditReportPage from './pages/report/AdminEditReportPage';
import AdminReportDownload from './pages/report/AdminReportDownload';
import AdminNotificationsPage from './pages/report/AdminNotificationsPage';
import StudentCurriculums from './pages/report/StudentCurriculums';
import StudentKarte from './pages/report/StudentKarte';

// 共通リダイレクト
import RedirectExternal from './components/RedirectExternal';
import NotFoundPage from "./pages/NotFoundPage";
import BadRequestPage from "./pages/BadRequestPage";
import ErrorPage from "./pages/ErrorPage";
import LogoutPage from "./pages/LogoutPage";

/**
 * 報告書アプリ専用ルーター
 * ドメインが report アプリのときに利用
 */
export default function AppReportRouter({
    isLoggedIn,
    userRole,
    teacherName,
    adminEmail,
    selectedStudents,
    setSelectedStudents,
    isAdminLogin,
    isTeacherLogin,
    getLoginUrl,
    handleLogout,
}) {

    const [unreadCount, setUnreadCount] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    // 教師未読件数を取得
    useEffect(() => {
        if (isLoggedIn && userRole === 'teacher') {
            (async () => {
                try {
                    // includeRead=false で未読のみを取得、limit=1 で存在チェック
                    const data = await getRequest('notifications/list?includeRead=false&limit=1');
                    setUnreadCount(data.length);
                    console.log("data", data.length);
                } catch (err) {
                    console.error('未読通知取得エラー:', err);
                }
            })();
        }
    }, [isLoggedIn, userRole]);

    return (
        <Routes>
            <Route
                path="/"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole === 'admin' ? (
                        <Navigate to="/approval" replace />
                    ) : userRole === "teacher" ? (
                        // unreadCount が null の間は何も出さず待機
                        unreadCount === null ? null :
                            // 判定後、未読なら /notifications、未読なければ既存フロー
                            unreadCount > 0
                                ? <Navigate to="/notifications" replace />
                                : selectedStudents.length > 0
                                    ? <Navigate to="/report" replace />
                                    : <Navigate to="/select-students" replace />
                    ) : (
                        <Navigate to="/" replace />
                    )
                }
            />

            {/* 教師専用ルート */}
            <Route
                path="/report"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "teacher" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        selectedStudents.length > 0 ? (
                            <TeacherDashboard
                                teacherName={teacherName}
                                selectedStudents={selectedStudents}
                                setSelectedStudents={setSelectedStudents}
                            />
                        ) : (
                            <Navigate to="/select-students" replace />
                        )
                    )
                }
            />
            <Route
                path="/notifications"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "teacher" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <TeacherNotificationsPage />
                    )
                }
            />
            <Route
                path="/select-students"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "teacher" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <TodayStudentSelection
                            selectedStudents={selectedStudents}
                            setSelectedStudents={setSelectedStudents}
                        />
                    )
                }
            />
            <Route
                path="/goal"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : (
                        <StudentGoalsPage />
                    )
                }
            />
            <Route
                path="/curriculums"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : (
                        <StudentCurriculums />
                    )
                }
            />
            <Route
                path="/karte"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : (
                        <StudentKarte />
                    )
                }
            />

            {/* 管理者専用ルート */}
            <Route
                path="/notify"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminNotificationsPage />
                    )
                }
            />
            <Route
                path="/approval"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminDashboard adminEmail={adminEmail} onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/teachers"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminTeachers onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/students"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminStudents onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/parents"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminParents onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/assignments"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminTeacherAssignments onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/reports"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminReportsPage />
                    )
                }
            />
            <Route
                path="/reports/edit/:reportId"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminEditReportPage />
                    )
                }
            />
            <Route
                path="/reports/download"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminReportDownload />
                    )
                }
            />

            <Route path="/error/400" element={<BadRequestPage />} />
            <Route path="/error/404" element={<NotFoundPage />} />
            <Route path="/error/500" element={<ErrorPage />} />
            <Route path="/logout" element={<LogoutPage onLogout={handleLogout} />} />
            <Route path="*" element={<Navigate to="/error/404" replace />} />
        </Routes>
    );
}
